import { useState, useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Zap, Waves, Camera, Mountain, Bike, Sunset, Users, Heart,
  Theater, Utensils, Train, Binoculars, Anchor, MapPin, History
} from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import SEO from '@/components/SEO';

const ActivitiesPage = () => {
  const activities = [
    // --- ZIMBABWE ACTIVITIES ---
    {
      icon: Zap,
      name: 'Bungee Jumping (Solo)',
      location: 'Victoria Falls Bridge',
      description: 'The world-famous 111m leap from the Victoria Falls Bridge. Requires passport for bridge access.',
      duration: '1 hour',
      difficulty: 'Extreme',
      image: '/images/8-6.jpg',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$180'
    },
    {
      icon: Zap,
      name: 'Bridge Swing (Solo)',
      location: 'Victoria Falls Bridge',
      description: 'Step off the bridge into a 111m freefall before swinging in a massive arc over the Zambezi.',
      duration: '1 hour',
      difficulty: 'Extreme',
      image: '/images/2.jpg',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$180'
    },
    {
      icon: Zap,
      name: 'Gorge Swing (Solo)',
      location: 'Batoka Gorge (Zim)',
      description: 'A 70m freefall into the Batoka Gorge followed by a 95m long arc swing.',
      duration: '1 hour',
      difficulty: 'Extreme',
      image: '/images/the-victoria-falls-gorge-swing-1-1024x464.jpg',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$115'
    },
    {
      icon: Zap,
      name: 'Big Air Experience',
      location: 'Victoria Falls Bridge',
      description: 'The ultimate bridge combo including Bungee Jump, Bridge Swing, and Bridge Slide.',
      duration: '3 hours',
      difficulty: 'Extreme',
      image: '/images/0ed3e547-bb95-4389-a07b-69bb2f788d9ea42cf1b.webp',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$265'
    },
    {
      icon: Zap,
      name: 'Zip Line (Solo)',
      location: 'Batoka Gorge',
      description: 'Race across the gorge at speeds up to 106km/h on the longest zip line in the world.',
      duration: '1 hour',
      difficulty: 'High',
      image: '/images/Bridge-Slide-7-scaled.jpg',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$95'
    },
    {
      icon: Zap,
      name: 'Bridge Slide (Solo)',
      location: 'Victoria Falls Bridge',
      description: 'Slide across the Batoka Gorge from Zimbabwe to Zambia with stunning views.',
      duration: '1 hour',
      difficulty: 'Moderate',
      image: '/images/5.jpg',
      category: 'Adrenaline Activities',
      place: 'Zimbabwe',
      price: '$55'
    },
    {
      icon: Heart,
      name: 'Flight of Angels (12-13 Min)',
      location: 'Victoria Falls',
      description: 'The classic helicopter flight over the Falls. Stunning views of the world wonder.',
      duration: '13 minutes',
      difficulty: 'Easy',
      image: '/images/Heli-Shoot-710256.jpg',
      category: 'Air Activities',
      place: 'Zimbabwe',
      price: '$165'
    },
    {
      icon: Heart,
      name: 'Zambezi Spectacular (25 Min)',
      location: 'Victoria Falls & Gorge',
      description: 'Extended flight over the Falls, Batoka Gorge, and the Zambezi National Park.',
      duration: '25 minutes',
      difficulty: 'Easy',
      image: '/images/Heli-Flight4.jpg',
      category: 'Air Activities',
      place: 'Zimbabwe',
      price: '$315'
    },
    {
      icon: Waves,
      name: 'White Water Rafting (Full Day)',
      location: 'Zambezi River',
      description: 'Navigate the world-renowned Grade 5 rapids of the Zambezi River. Includes lunch.',
      duration: '7 hours',
      difficulty: 'High',
      image: '/images/whitewater-rafting-images-10.jpg',
      category: 'Water Activities',
      place: 'Zimbabwe',
      price: '$140'
    },
    {
      icon: Waves,
      name: 'Adventure Jetboat',
      location: 'Zambezi River',
      description: 'High-speed thrill ride to the base of the Falls. Experience the "Boiling Pot" up close.',
      duration: '2.5 hours',
      difficulty: 'High',
      image: '/images/DSC01108.jpg',
      category: 'Water Activities',
      place: 'Zimbabwe',
      price: '$120'
    },
    {
      icon: Sunset,
      name: 'The Riversong Luxury Cruise',
      location: 'Zambezi River',
      description: "Shearwater's premier luxury cruise. Premium snacks and high-end drinks included.",
      duration: '2.5 hours',
      difficulty: 'Easy',
      image: '/images/Riversong-2-10.jpg',
      category: 'Water Activities',
      place: 'Zimbabwe',
      price: '$90'
    },
    {
      icon: Camera,
      name: 'Hwange National Park Day Trip',
      location: 'Hwange National Park',
      description: 'Full-day safari to Hwange including breakfast and picnic lunch. Spot the Big Five.',
      duration: 'Full Day',
      difficulty: 'Easy',
      image: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=1000&q=80',
      category: 'Safari Activities',
      place: 'Zimbabwe',
      price: '$320'
    },
    {
      icon: Mountain,
      name: 'Through The Eyes Of An Elephant',
      location: 'Elephant Conservation Hub',
      description: 'Educational elephant interaction and guided walk focused on conservation.',
      duration: '3 hours',
      difficulty: 'Easy',
      image: '/images/6-11.jpg',
      category: 'Safari Activities',
      place: 'Zimbabwe',
      price: '$130'
    },
    {
      icon: Theater,
      name: 'Simunye: Spirit of Africa',
      location: 'Victoria Falls Theatre',
      description: 'Award-winning theatrical production combining dance, music, and puppetry.',
      duration: '1 hour',
      difficulty: 'Easy',
      image: '/images/Simunye-Spirit-Of-Africa-31.jpg',
      category: 'Cultural',
      place: 'Zimbabwe',
      price: '$40'
    },
    {
      icon: Train,
      name: 'Bushtracks Express Dinner Safari',
      location: 'Victoria Falls Bridge',
      description: 'Luxury historic train dinner safari with five-course meal on the Bridge.',
      duration: '4 hours',
      difficulty: 'Easy',
      image: '/images/screenshot-from-2024-06-18-16-21-43.b7f683f9.png',
      category: 'Cultural',
      place: 'Zimbabwe',
      price: '$240'
    },
    {
      icon: History,
      name: 'Historical Bridge Tour',
      location: 'Victoria Falls Bridge',
      description: 'Theatrical presentation of bridge history followed by a catwalk walk beneath.',
      duration: '2 hours',
      difficulty: 'Moderate',
      image: '/images/Bridge-Tour-1-scaled.jpg',
      category: 'Cultural',
      place: 'Zimbabwe',
      price: '$70'
    },
    {
      icon: Users,
      name: 'Village Visit',
      location: 'Victoria Falls Rural',
      description: 'Immerse yourself in authentic rural life and meet the local community.',
      duration: '2 hours',
      difficulty: 'Easy',
      image: '/images/Traditional-Village-tour-3-scaled.jpg',
      category: 'Cultural',
      place: 'Zimbabwe',
      price: '$65'
    },

    // --- ZAMBIA ACTIVITIES ---
    {
      icon: Train,
      name: 'Royal Livingstone Express Dinner',
      location: 'Victoria Falls Bridge (Zambia)',
      description: 'Historic train safari with a 5-course meal on the Victoria Falls Bridge.',
      duration: '4 hours',
      difficulty: 'Easy',
      image: '/images/Royal-Livingstone-Express.jpg',
      category: 'Cultural',
      place: 'Zambia',
      price: '$220'
    },
    {
      icon: Heart,
      name: 'Microlight Flight (15 Min)',
      location: 'Livingstone (Zambia)',
      description: 'An exhilarating open-cockpit flight over the Falls. The ultimate "wind in your face" experience.',
      duration: '15 minutes',
      difficulty: 'Moderate',
      image: '/images/Microlight-flight-safari-on-Victoria-Falls-1024x409.jpg',
      category: 'Air Activities',
      place: 'Zambia',
      price: '$196'
    },
    {
      icon: Heart,
      name: 'Zambia Helicopter Flight (15 Min)',
      location: 'Livingstone (Zambia)',
      description: 'Breathtaking helicopter flip over the Victoria Falls and the Zambezi River.',
      duration: '15 minutes',
      difficulty: 'Easy',
      image: '/images/uac_2.jpg',
      category: 'Air Activities',
      place: 'Zambia',
      price: '$211'
    },
    {
      icon: Utensils,
      name: 'Livingstone Island Morning Breezer',
      location: 'Victoria Falls Edge',
      description: "Visit the edge of Victoria Falls on Livingstone Island. Includes breakfast and the chance to swim in Devil's Pool or Angel's Pool (seasonal). Rates: Green ($149), Peak ($159).",
      duration: '1.5 hours (07:30, 09:00, 10:30)',
      difficulty: 'Moderate',
      image: '/images/c0.jpg',
      category: 'Water Activities',
      place: 'Zambia',
      price: '$149 - $159'
    },
    {
      icon: Utensils,
      name: 'Livingstone Island Lunch',
      location: 'Edge of the Falls',
      description: "A five-star gourmet lunch on Livingstone Island, perched right on the edge of the abyss. Rates: Green ($199), Peak ($209).",
      duration: '2.5 hours (12:30)',
      difficulty: 'Moderate',
      image: '/images/the_royal_livingstone_kubu_960x519.jpg',
      category: 'Water Activities',
      place: 'Zambia',
      price: '$199 - $209'
    },
    {
      icon: Utensils,
      name: 'Livingstone Island Afternoon Tea',
      location: 'Victoria Falls Edge',
      description: "A classic British-style high tea served on the island with panoramic views of the Falls. Rates: Green ($189), Peak ($199).",
      duration: '2 hours (15:30)',
      difficulty: 'Moderate',
      image: '/images/group-waiting-at-royal-livingstone-hotel-for-boat-to-devils-pool.webp',
      category: 'Water Activities',
      place: 'Zambia',
      price: '$189 - $199'
    },
    {
      icon: Mountain,
      name: 'Livingstone Island Walks',
      location: 'Livingstone Island',
      description: "Guided walks on Livingstone Island during the low water season (01 Aug - 31 Dec only). Deeply immersive experience of the Falls' edge.",
      duration: '2 hours (06:15, 09:15, 11:15, 14:15)',
      difficulty: 'Moderate',
      image: '/images/livi_history_heritage_desktop.webp',
      category: 'Cultural',
      place: 'Zambia',
      price: '$100'
    },
    {
      icon: Utensils,
      name: 'The Elephant Cafe (Speedboat)',
      location: 'Zambezi River, Livingstone',
      description: 'Speedboat transfer, elephant interaction, and fine dining at the award-winning Elephant Cafe.',
      duration: '3.5 hours',
      difficulty: 'Easy',
      image: '/images/Elephant_Cafe_Exterior.webp',
      category: 'Cultural',
      place: 'Zambia',
      price: '$260'
    },
    {
      icon: Mountain,
      name: 'White Rhino Walking Safari',
      location: 'Mosi-Oa-Tunya Park',
      description: 'Track the rare white rhino on foot with professional armed rangers in Zambia.',
      duration: '3 hours',
      difficulty: 'Moderate',
      image: '/images/caption.jpg',
      category: 'Safari Activities',
      place: 'Zambia',
      price: '$144'
    },
    {
      icon: Bike,
      name: 'Quad Biking - Eco Trail',
      location: 'Livingstone (Zambia)',
      description: 'Guided quad bike adventure through the African bush and local trails.',
      duration: '1 hour',
      difficulty: 'Moderate',
      image: '/images/livingstone-quad-biking-60-minute-eco-trail-1488051-1024x684.jpg',
      category: 'Adrenaline Activities',
      place: 'Zambia',
      price: '$90'
    },
    {
      icon: Sunset,
      name: 'African Queen Sunset Cruise',
      location: 'Zambezi River (Zambia)',
      description: 'Luxury sunset cruise on the African Queen. Includes snacks and premium beverages.',
      duration: '2 hours',
      difficulty: 'Easy',
      image: '/images/approaching-the-african.jpg',
      category: 'Water Activities',
      place: 'Zambia',
      price: '$75'
    },
    {
      icon: MapPin,
      name: 'Victoria Falls Guided Tour',
      location: 'Livingstone (Zambia)',
      description: 'Walk the Zambian side of the Falls including the Knife Edge Bridge and Eastern Cataract.',
      duration: '2 hours',
      difficulty: 'Easy',
      image: '/images/8-2.jpg',
      category: 'Cultural',
      place: 'Zambia',
      price: '$34'
    },
    {
      icon: History,
      name: 'Historic Bridge Tour',
      location: 'Victoria Falls Bridge',
      description: 'Step back in time with a theatrical bridge tour and a walk on the catwalks.',
      duration: '2 hours',
      difficulty: 'Easy',
      image: '/images/bridge-tour-9.jpg',
      category: 'Cultural',
      place: 'Zambia',
      price: '$55'
    },
    {
      icon: Waves,
      name: 'Zambezi River Float',
      location: 'Upper Zambezi',
      description: 'A relaxing float down the river in rafts. Perfect for birdwatching and scenery.',
      duration: '4 hours',
      difficulty: 'Easy',
      image: '/images/drifting down the zambezi compressed.webp',
      category: 'Water Activities',
      place: 'Zambia',
      price: '$130'
    },

    // --- BOTSWANA ACTIVITIES ---
    {
      icon: Camera,
      name: 'Chobe Day Trip (Full Day)',
      location: 'Chobe National Park',
      description: 'Full-day Botswana safari including river cruise, lunch, and game drive.',
      duration: 'Full Day',
      difficulty: 'Easy',
      image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1000&q=80',
      category: 'Day Trips',
      place: 'Botswana',
      price: '$198'
    },
    {
      icon: Anchor,
      name: 'Chobe River Cruise',
      location: 'Chobe River',
      description: '3-hour river safari to see massive elephant herds and hippos from the water.',
      duration: '3 hours',
      difficulty: 'Easy',
      image: '/images/bigstock_Botswana_Chobe_River_African_Elephants_Safari_Cruise-1200x704.jpg',
      category: 'Water Activities',
      place: 'Botswana',
      price: '$53'
    },
    {
      icon: Binoculars,
      name: 'Chobe Game Drive',
      location: 'Chobe National Park',
      description: "Guided open 4x4 safari drive through Botswana's premier elephant park.",
      duration: '3 hours',
      difficulty: 'Easy',
      image: '/images/80.jpg',
      category: 'Safari Activities',
      place: 'Botswana',
      price: '$53'
    },
    {
      icon: Waves,
      name: 'Mokoro Excursion',
      location: 'Khwai River',
      description: 'Experience the tranquility of the Okavango Delta on a traditional dugout canoe.',
      duration: '2-3 hours',
      difficulty: 'Easy',
      image: '/images/khwai-mokoro.png',
      category: 'Water Activities',
      place: 'Botswana',
      price: '$44'
    },
    {
      icon: Binoculars,
      name: 'Khwai Nature Walk',
      location: 'Khwai Concession',
      description: 'Explore the African bush on foot with a professional guide, focusing on tracks and signs.',
      duration: '2 hours',
      difficulty: 'Moderate',
      image: '/images/khwai-walk.png',
      category: 'Safari Activities',
      place: 'Botswana',
      price: '$60'
    },
    {
      icon: Camera,
      name: 'Khwai Night Drive',
      location: 'Khwai Concession',
      description: 'Search for nocturnal predators and experience the bush after dark in the Khwai area.',
      duration: '1 hour',
      difficulty: 'Easy',
      image: '/images/khwai-night-drive.png',
      category: 'Safari Activities',
      place: 'Botswana',
      price: '$75',
    }
  ];

  const categories = ['All', 'Air Activities', 'Water Activities', 'Adrenaline Activities', 'Safari Activities', 'Day Trips', 'Cultural'];
  const places = ['All', 'Zambia', 'Zimbabwe', 'Botswana'];

  const [searchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState(searchParams.get('category') || 'All');
  const [activePlace, setActivePlace] = useState(searchParams.get('place') || 'All');

  useEffect(() => {
    const placeParam = searchParams.get('place');
    const categoryParam = searchParams.get('category');
    if (placeParam) setActivePlace(placeParam);
    if (categoryParam) setActiveCategory(categoryParam);
  }, [searchParams]);



  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Easy': return 'bg-accent/10 text-accent';
      case 'Moderate': return 'bg-secondary/10 text-secondary-foreground';
      case 'High': return 'bg-primary/10 text-primary';
      case 'Extreme': return 'bg-destructive/10 text-destructive';
      default: return 'bg-muted text-muted-foreground';
    }
  };



  return (
    <div className="min-h-screen">
      <SEO
        title="Activities"
        description="Complete guide to activities in Victoria Falls and beyond. Book bungee jumping, sunset cruises, game drives, and cultural tours."
        keywords="Victoria Falls Activities, Safari Activities, Bungee Jumping, White Water Rafting, Sunset Cruise, Game Drive"
        canonicalUrl="https://www.peregrinetoursandsafaris.com/activities"
        schema={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "African Adventures and Activities",
          "description": "A comprehensive collection of safari, water, and adrenaline activities in Southern Africa.",
          "itemListElement": activities.map((activity, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "Product",
              "name": activity.name,
              "description": activity.description,
              "image": activity.image.startsWith('/')
                ? `https://www.peregrinetoursandsafaris.com${activity.image}`
                : activity.image,
              "offers": {
                "@type": "Offer",
                "price": activity.price.replace(/[^0-9.]/g, ''),
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
              }
            }
          }))
        }}
      />

      <Navbar />

      <section className="relative pt-32 pb-16 bg-gradient-to-b from-muted/30 to-background">
        <div className="container-custom text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-6 font-serif">
            2026 Activity Guide
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the best of Southern Africa with our official activities across Zimbabwe, Zambia, and Botswana.
          </p>
        </div>
      </section>

      {/* Place & Category Filters */}
      <section className="py-8 bg-background border-y border-border">
        <div className="container-custom space-y-6">
          <div className="flex flex-wrap justify-center gap-3">
            <span className="w-full text-center text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground mb-2">Location</span>
            {places.map((place) => (
              <button
                key={place}
                onClick={() => setActivePlace(place)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${activePlace === place
                  ? 'bg-primary text-primary-foreground shadow-lg'
                  : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
                  }`}
              >
                {place}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            <span className="w-full text-center text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground mb-2">Activity Type</span>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-300 ${activeCategory === category
                  ? 'bg-accent text-accent-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-accent/10 hover:text-accent'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Activities Grid */}
      <section className="section-padding bg-background">
        <div className="container-custom space-y-16">
          {(activePlace === 'All' ? places.filter(p => p !== 'All') : [activePlace]).map((place) => {
            const placeActivities = activities.filter(activity =>
              activity.place === place &&
              (activeCategory === 'All' || activity.category === activeCategory)
            );

            if (placeActivities.length === 0) return null;

            return (
              <div key={place} className="space-y-6">
                <div className="flex items-center gap-4">
                  <h2 className="text-2xl font-bold font-serif text-foreground">{place} Activities</h2>
                  <div className="h-px bg-border flex-1" />
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {placeActivities.map((activity, index) => {
                    const Icon = activity.icon;
                    return (
                      <Card key={activity.name} className="group overflow-hidden border-2 hover:border-primary/30 transition-all duration-300 flex flex-col">
                        <div className="relative h-56 overflow-hidden">
                          <img src={activity.image} alt={activity.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                          <div className="absolute top-4 right-4 w-10 h-10 bg-primary/90 rounded-full flex items-center justify-center text-primary-foreground shadow-xl">
                            <Icon className="w-5 h-5" />
                          </div>
                          <div className="absolute top-4 left-4 bg-background/95 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2">
                            <MapPin className="w-3 h-3 text-primary" />
                            <span className="text-[10px] font-bold text-foreground uppercase tracking-wider">{activity.place}</span>
                          </div>
                          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                            <h3 className="text-xl font-bold text-white font-serif">{activity.name}</h3>
                          </div>
                        </div>

                        <div className="p-6 flex-1 flex flex-col">
                          <p className="text-muted-foreground text-sm leading-relaxed mb-6 flex-1">{activity.description}</p>

                          <div className="flex items-center justify-between mb-6 text-[10px] font-bold uppercase tracking-widest">
                            <span className="px-2 py-1 bg-muted rounded text-muted-foreground">{activity.duration}</span>
                            <span className={`px-2 py-1 rounded ${getDifficultyColor(activity.difficulty)}`}>{activity.difficulty}</span>
                          </div>

                          <div className="flex items-center justify-between py-4 border-t border-border mt-auto">
                            <div className="flex flex-col">
                              <span className="text-2xl font-black text-primary">{activity.price}</span>
                              <span className="text-[9px] text-muted-foreground uppercase">Rack Rate 2026</span>
                            </div>
                            <Button asChild className="bg-primary hover:bg-primary-dark text-primary-foreground px-6 shadow-md hover:shadow-lg transition-all">
                              <Link to="/booking" state={{ bookItem: activity.name }}>
                                Book Now
                              </Link>
                            </Button>
                          </div>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ActivitiesPage;